/**
 * Formatação de datas vindas da API.
 *
 * Os campos DateOnly do backend chegam como "2026-08-31" (sem hora e sem fuso).
 * `new Date("2026-08-31")` é interpretado pelo JS como MEIA-NOITE EM UTC — no
 * horário de Brasília (UTC-3) isso vira 30/08 às 21h, e a tela mostrava um dia a
 * menos que o cadastrado. Campos DateTime ("2026-08-31T00:00:00", sem Z) já são
 * lidos como hora local e não têm esse problema.
 *
 * Por isso a data pura é formatada direto da string, sem passar por Date.
 */

const SO_DATA = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Data em dd/mm/aaaa. Aceita DateOnly ("2026-08-31") e DateTime. */
export const fmtData = (d, vazio = null) => {
  if (!d) return vazio;
  const m = SO_DATA.exec(String(d).trim());
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const dt = new Date(d);
  return isNaN(dt) ? vazio : dt.toLocaleDateString("pt-BR");
};

/** Data e hora em dd/mm/aaaa hh:mm:ss. Data pura sai sem hora (não há o que exibir). */
export const fmtDataHora = (d, vazio = "—") => {
  if (!d) return vazio;
  if (SO_DATA.test(String(d).trim())) return fmtData(d, vazio);
  const dt = new Date(d);
  return isNaN(dt) ? vazio : dt.toLocaleString("pt-BR");
};
